/**
 * Telegram WebApp haptic feedback wrapper. No-op when running outside
 * a Telegram WebView (browser preview, missing API, older clients).
 *
 * Five kinds:
 *  - "light"   — selection / tap of a small UI element
 *  - "medium"  — primary action confirmation (Send, Swap, Save)
 *  - "success" — successful outcome (broadcast, copy, save)
 *  - "warning" — needs-attention state (low memory, "are you sure")
 *  - "error"   — failure outcome (broadcast failed, validation)
 */
export type HapticKind = "light" | "medium" | "success" | "warning" | "error";

export function haptic(kind: HapticKind): void {
  const hf = window.Telegram?.WebApp?.HapticFeedback;
  if (!hf) return;
  try {
    if (kind === "success" || kind === "warning" || kind === "error") {
      hf.notificationOccurred?.(kind);
    } else {
      hf.impactOccurred?.(kind);
    }
  } catch {
    /* older clients */
  }
}

/**
 * Selection-changed haptic — distinct from impact. Use for tab
 * switches, segmented-control flips, picker rotations.
 */
export function hapticSelection(): void {
  const hf = window.Telegram?.WebApp?.HapticFeedback;
  if (!hf) return;
  try {
    (hf as unknown as { selectionChanged?: () => void }).selectionChanged?.();
  } catch {
    /* older clients */
  }
}
